import type { ComponentTheme } from '../types/component-theme';

import { WorkflowChecklistItemStates } from './constants/workflow-checklist-item';

export default {
    slots: {
        root:
            'flex items-center gap-[0.7rem] border-b-[0.063rem] border-solid border-b-(--slate-alpha-12) px-4 py-3 ' +
            'transition-[background-color,border-color,opacity] duration-200 last:border-b-0',
        icon: 'mt-[0.063rem] shrink-0 transition-colors duration-200',
        content: 'flex min-w-0 flex-1 flex-col gap-[0.18rem]',
        label: 'font-(family-name:--primary-font) text-[0.7rem] font-extrabold uppercase tracking-[0.07em]',
        value:
            'relative pl-4 whitespace-normal wrap-break-word text-pretty before:absolute before:left-0 ' +
            'before:content-["•"] font-(family-name:--secondary-font) text-[0.84rem] leading-[1.4]',
        currentBadge:
            'hidden mt-0.5 shrink-0 rounded-[6.188rem] px-[0.55rem] py-[0.18rem] font-(family-name:--secondary-font) ' +
            'text-[0.63rem] font-bold uppercase tracking-[0.06em] text-(--pure-white) ' +
            'shadow-(--progress-glow-shadow-xs) bg-(image:--accent-gradient)'
    },
    variants: {
        variant: {
            [WorkflowChecklistItemStates.Completed]: {
                root: '[border-left:0.188rem_solid_var(--workflow-completed-accent)]',
                icon: 'text-(--workflow-completed-accent)',
                label: 'text-(--text-light)',
                value: 'font-semibold text-(--text-dark)'
            },
            [WorkflowChecklistItemStates.Current]: {
                root: 'bg-(--indigo-alpha-06) [border-left:0.188rem_solid_var(--accent-solid)]',
                icon: 'text-(--accent-solid)',
                label: 'text-(--accent-solid)',
                value: 'font-semibold text-(--text-dark)',
                currentBadge: 'inline-flex'
            },
            [WorkflowChecklistItemStates.Available]: {
                root: '[border-left:0.188rem_solid_transparent]',
                icon: 'text-(--text-muted)',
                label: 'text-(--text-light)',
                value: 'font-semibold text-(--text-dark)'
            },
            [WorkflowChecklistItemStates.Locked]: {
                root: '[border-left:0.188rem_solid_transparent] opacity-[0.38]',
                icon: 'text-(--text-muted)',
                label: 'text-(--text-muted)',
                value: 'italic text-(--text-light)'
            }
        }
    }
} satisfies ComponentTheme;
